import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog' 
import { useToast } from '@/components/ui/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { isAxiosError } from '@/api/business'
import { informOperationInNF } from '@/api/business/cockpit'
import { Cockpit } from '@/queries/useCockpitQuery'
import Button from '@/components/Button' 
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,

} from '@/components/ui/form' 
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'  
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"
import { useOperationQuery } from '@/queries/useOperationQuery'
import { useEffect } from 'react'
import { Nf } from '@/api/business/cockpit/type'
import { Skeleton } from '@/components/ui/skeleton'

interface OperationHubProps {
    NF: Nf 
    isOpen: boolean 
    onClose: () => void
}

const InformOperation = ({ isOpen, onClose, NF}: OperationHubProps) => {
    const queryClient = useQueryClient() 
    const { toast } = useToast() 

    const { data, isFetching } = useOperationQuery()

    let operations = data?.filter(item => item.DD_CNPJ_FORNECEDOR == NF.DD_CNPJ_EMITENTE && item.DD_CNPJ_DESTINO == NF.DD_CNPJ_DESTINATARIO )

    const schema = z.object({
        SK_CABECALHO_OPERACAO: z.number(), 
    })

    useEffect(() => {
        if(data){
            operations = operations?.filter(item => item.DD_CNPJ_FORNECEDOR == NF.DD_CNPJ_EMITENTE && item.DD_CNPJ_DESTINO == NF.DD_CNPJ_DESTINATARIO )
        }
     }, [NF,data]);

    const form = useForm<z.infer<typeof schema>>({
        resolver: zodResolver(schema),
        defaultValues: { 
            SK_CABECALHO_OPERACAO: 0
        },
    })

    const { mutate, isPending: mutateLoading } = useMutation({
        mutationFn: informOperationInNF,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: Cockpit.details() })
            onClose()
            form.reset() 
            toast({
                title: 'Operação informada com sucesso',
            })
        },
        onError: (err) => {
            let errorMessage =
                'Não foi possível atualizar a operação. Tente novamente mais tarde.'

            if (isAxiosError(err)) {
                errorMessage = err.response?.data.message || errorMessage
            }

            toast({
                title: 'Erro ao informar a atualizar operação',
                description: errorMessage,
                variant: 'destructive',
            })
        },
    })

    const onSubmit = (data: z.infer<typeof schema>) => {
        console.log(data)
        mutate({
            SK_NF: NF.SK_NF,
            ...data
        })
    }

    return (
        <Dialog open={isOpen} onOpenChange={onClose}  >
            <DialogContent className='bg-gray-800 border-none max-w-[400px]' aria-describedby=''>
                <DialogHeader>
                    <DialogTitle className='flex justify-between items-end'> 
                        Informar Operação
                    </DialogTitle>
                </DialogHeader>
                {isFetching && <Skeleton className="h-[34px] bg-gray-300" />}
                {
                    !isFetching && (
                        operations && operations?.length > 0 ? (
                                <Form {...form}>
                                    <form
                                        onSubmit={form.handleSubmit(onSubmit)}
                                        className="space-y-2 px-2 overflow-hidden overflow-y-auto"
                                    >
                                        <FormField
                                            name="SK_CABECALHO_OPERACAO"
                                            control={form.control}
                                            render={({ field }) => (
                                                <FormItem>
                                                    <FormLabel>Operação</FormLabel>
                                                    <Select onValueChange={(value) => field.onChange(Number(value))} defaultValue={field.value.toString()}>
                                                        <FormControl>
                                                            <SelectTrigger>
                                                                <SelectValue placeholder="" />
                                                            </SelectTrigger>
                                                        </FormControl>
                                                        <SelectContent className='h-28'>
                                                            {operations?.map((companies) => (
                                                                <SelectItem key={companies.SK_OPERACAO} value={companies.SK_OPERACAO.toString()}>{companies.SK_OPERACAO} | {companies.NM_RAZAO_SOCIAL}</SelectItem>
                                                            ))
                                                            }
                                                        </SelectContent>
                                                    </Select>
                                                    <FormMessage />
                                                </FormItem>
                                            )}
                                        />
                                        <DialogFooter>
                                            <Button
                                                type="button"
                                                onClick={onClose}
                                                variant="ghost"
                                            >
                                                Cancelar
                                            </Button>
                                            <Button type="submit" isLoading={mutateLoading}>
                                                Confirmar
                                            </Button>
                                        </DialogFooter>
                                    </form>
                                </Form>
                        ) : (
                            <h1>Não foi encontrado operações correspondente ao fornecedor</h1>
                        )
                    )
                }
                <DialogFooter> 
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default InformOperation
